import { render } from "./ManageImagesPage.vue?vue&type=template&id=5f1884a5&scoped=true"
import script from "./ManageImagesPage.vue?vue&type=script&lang=js"
export * from "./ManageImagesPage.vue?vue&type=script&lang=js"

import "./ManageImagesPage.vue?vue&type=style&index=0&id=5f1884a5&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/ContentMoverNodejs/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1884a5"]])

export default __exports__